import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import * as Config from '../../app/app.config';
import {AuthProvider} from '../auth/auth';

import {Storage} from '@ionic/storage';
import {Platform} from 'ionic-angular';

/*
  Generated class for the ProofServerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class VoucherServerProvider {

  // private medias: MediaItem[];
  // private mediasSuccess: any[];

  constructor(
    private http: Http,
    private auth: AuthProvider,
    // private proofProvider: ProofProvider,
    private storage: Storage,
    private platform: Platform,
    // private mediaProvider: MediaProvider,
    // private file: File,
    // private fileProvider: FileProvider
  ) {
    console.log('Hello VoucherServerProvider Provider');
  }

  /**
   * Validate voucher.
   */
  public validateVoucher(proof_id: string, voucherCode: string) {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();
    let formData = {'proof_id': proof_id, 'voucher_code': voucherCode};

    return this.http.post(Config.baseUrl + '/vouchers/validate', formData, {headers: headers})
      .map((res: Response) => res.json());
  }


  /**
   * Validate voucher api.
   */
  public validateVoucherApi(proof_id: string, voucherCode: string) {
    //let that = this;
    //let headers = that.auth.createApplicationHeadersWithBearer();
    //headers.append('Access-Control-Allow-Origin', '*');
    //headers.append('Access-Control-Allow-Methods', 'GET');
    //headers.append('Access-Control-Allow-Headers', 'Content-Type');
    //headers.append('Access-Control-Allow-Credentials', 'true');

    //return this.http.get(Config.baseUrlVoucher + proof_id+'/'+voucherCode, { headers: headers }).map((res: Response) => res.json());
    return this.http.get(Config.baseUrlVoucher + proof_id + '/' + voucherCode).map((res: Response) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/providers/voucher-server/voucher-server.ts